<template>
  <v-menu
    v-bind="$attrs"
    offset-x min-width="200" max-width="240"
    :left="left"
    :right="right"
    :nudge-right="right ? 4 : 0"
    :nudge-left="left ? 4 : 0"
    :close-on-content-click="false"
    v-model="open"
  >
    <template v-slot:activator="{ on }">
      <slot v-bind="{ on }" />
    </template>
    <div class="white d-flex flex-column" style="height: calc(100vh - 24px);">
      <slot name="header" v-bind="{ close: () => open = false }" />
      <div class="flex-grow-0 pa-3" @click.stop.prevent>
        <v-text-field
          label="Search" single-line dense clearable hide-details
          :append-icon="mdiMagnify"
          v-model="filter"
        />
        <v-checkbox v-if="fonts" class="mt-3 ml-n1" dense hide-details label="Show all fonts" v-model="showAll" />
      </div>
      <v-divider class="flex-grow-0" />
      <div class="flex-grow-1">
        <!-- Note that use the 'openDelay' so we can wait for the animation to complete, otherwise the v-virtual-scroll won't render any items initially (because it has no height) -->
        <v-virtual-scroll v-if="openDelay" class="fill-height v-list--dense" :items="filtered" :item-height="40">
          <template v-slot:default="{ item }">
            <v-list-item :input-value="item == value" @click.stop="$emit('input', item)">
              <v-list-item-title v-bind:style="{ 'font-family': getFontFamily(item) }" v-html="item" />
            </v-list-item>
          </template>
        </v-virtual-scroll>
      </div>
    </div>
  </v-menu>
</template>

<script>
import ALL_FONTS from '@/utils/fonts.js';
import loadFont from '@/utils/load-font.js';
import { mdiClose, mdiMagnify } from '@mdi/js';


export default {
  name: 'font-picker-btn',

  props: [ 'fonts', 'value', 'left', 'right' ],

  data() {
    return {
      filter: null,
      showAll: false,
      open: false,
      openDelay: false
    };
  },

  computed: {
    filtered() {
      const fonts = (this.showAll || !this.fonts) ? ALL_FONTS : this.fonts;
      if (!this.filter)
        return fonts;
      const lower = this.filter.toLowerCase();
      return fonts.filter(x => x.toLowerCase().includes(lower));
    },

    needShowAll() {
      return !!this.value && !(this.fonts || ALL_FONTS).includes(this.value);
    }
  },

  created() {
    Object.assign(this, { mdiClose, mdiMagnify });
  },

  methods: {
    getFontFamily(font) {
      loadFont(font);
      return font;
    }
  },

  watch: {
    needShowAll: {
      immediate: true,
      handler(v) {
        if (v)
          this.showAll = true;
      }
    },

    open: {
      immediate: true,
      handler(v) {
        if (v)
          setTimeout(() => this.openDelay = true, 120);
        else
          this.openDelay = false;
      }
    }
  }
}
</script>
